import * as React from "react";
const SvgSvg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("title", null, "file_type_svg"), /* @__PURE__ */ React.createElement("path", { d: "M7.674,14.488a2.218,2.218,0,1,0,0,3.137H24.326a2.218,2.218,0,1,0,0-3.137Z", style: {
  fill: "#ffb13b",
  stroke: "#000",
  strokeWidth: "3.73000001907349px"
} }), /* @__PURE__ */ React.createElement("path", { d: "M11.222,9.06A2.218,2.218,0,1,0,9,11.278L20.778,23.052A2.218,2.218,0,1,0,23,20.834Z", style: {
  fill: "#ffb13b",
  stroke: "#000",
  strokeWidth: "3.73000001907349px"
} }), /* @__PURE__ */ React.createElement("path", { d: "M17.568,7.73a2.218,2.218,0,1,0-3.137,0V24.382a2.218,2.218,0,1,0,3.137,0Z", style: {
  fill: "#ffb13b",
  stroke: "#000",
  strokeWidth: "3.73000001907349px"
} }), /* @__PURE__ */ React.createElement("path", { d: "M23,11.278A2.218,2.218,0,1,0,20.778,9.06L9,20.834a2.218,2.218,0,1,0,2.218,2.218Z", style: {
  fill: "#ffb13b",
  stroke: "#000",
  strokeWidth: "3.73000001907349px"
} }), /* @__PURE__ */ React.createElement("path", { d: "M7.674,14.488a2.218,2.218,0,1,0,0,3.137H24.326a2.218,2.218,0,1,0,0-3.137Z", style: {
  fill: "#ffb13b"
} }), /* @__PURE__ */ React.createElement("path", { d: "M11.222,9.06A2.218,2.218,0,1,0,9,11.278L20.778,23.052A2.218,2.218,0,1,0,23,20.834Z", style: {
  fill: "#ffb13b"
} }), /* @__PURE__ */ React.createElement("path", { d: "M17.568,7.73a2.218,2.218,0,1,0-3.137,0V24.382a2.218,2.218,0,1,0,3.137,0Z", style: {
  fill: "#ffb13b"
} }), /* @__PURE__ */ React.createElement("path", { d: "M23,11.278A2.218,2.218,0,1,0,20.778,9.06L9,20.834a2.218,2.218,0,1,0,2.218,2.218Z", style: {
  fill: "#ffb13b"
} }), /* @__PURE__ */ React.createElement("path", { d: "M2,16.056H30V25.95a4.035,4.035,0,0,1-4.106,4.106H6.106A4.035,4.035,0,0,1,2,25.95Z" }), /* @__PURE__ */ React.createElement("path", { d: "M6.2,23.045A3.628,3.628,0,1,1,12.4,20.48H10.27A1.5,1.5,0,1,0,7.7,21.541h0a1.6,1.6,0,0,0,1.062.441h0a4.118,4.118,0,0,1,2.566,1.063h0a3.628,3.628,0,1,1-6.194,2.565H7.264A1.5,1.5,0,1,0,9.83,24.55h0a1.948,1.948,0,0,0-1.063-.44h0A4.465,4.465,0,0,1,6.2,23.045Z", style: {
  fill: "#fff"
} }), /* @__PURE__ */ React.createElement("path", { d: "M19.651,16.852,17.085,29.24H14.96L12.4,16.852H14.52l1.5,7.255,1.5-7.255Z", style: {
  fill: "#fff"
} }), /* @__PURE__ */ React.createElement("path", { d: "M23.28,21.983h3.628v3.628h0a3.628,3.628,0,1,1-7.257,0h0V20.48h0a3.628,3.628,0,0,1,7.257,0H24.783a1.5,1.5,0,1,0-3.005,0v5.13h0a1.5,1.5,0,0,0,3.005,0h0v-1.5h-1.5V21.983Z", style: {
  fill: "#fff"
} }));
export default SvgSvg;
